import { LineChart } from '@mui/x-charts/LineChart';
import DashboardCard, { EmptyState } from './DashboardCard';
import { chartColors, fmtShortDate, fromIsoDate } from './formatters';

/** Daily (or weekly, for long ranges) activations, new installations and released licenses. */
export default function ActivationsTrendChart({ series = [], bucket = 'day', sx }) {
  const hasData = series.some((s) => s.activations || s.released);

  return (
    <DashboardCard
      title={`Activations and deactivations per ${bucket}`}
      subtitle="Refreshes are re-activations that replace an earlier activation on the same license"
      sx={sx}
    >
      {hasData ? (
        <LineChart
          height={300}
          margin={{ left: 56, right: 24, top: 48, bottom: 28 }}
          grid={{ horizontal: true }}
          // x-charts 7 legend sizing (smaller marks and text than its default)
          slotProps={{ legend: { itemMarkWidth: 14, itemMarkHeight: 3, labelStyle: { fontSize: 13 } } }}
          xAxis={[
            {
              scaleType: 'point',
              data: series.map((s) => fromIsoDate(s.date)),
              valueFormatter: (d) => (bucket === 'week' ? `Week of ${fmtShortDate(isoOf(d))}` : fmtShortDate(isoOf(d))),
            },
          ]}
          series={[
            { id: 'activations', label: 'All activations', data: series.map((s) => s.activations), color: chartColors.activations, area: true, showMark: false, curve: 'linear' },
            { id: 'new', label: 'New installations', data: series.map((s) => s.newInstalls), color: chartColors.newInstalls, showMark: false, curve: 'linear' },
            { id: 'released', label: 'Released', data: series.map((s) => s.released), color: chartColors.released, showMark: false, curve: 'linear' },
          ]}
          // Class names differ between MUI X versions, so match any area path.
          sx={{ '& .MuiAreaElement-root, & [class*="AreaElement"], & [class*="area"] path, & path[class*="area"]': { fillOpacity: 0.15 } }}
        />
      ) : (
        <EmptyState>No activations in this range</EmptyState>
      )}
    </DashboardCard>
  );
}

const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
